import { isDisposalType, SiteEntity, siteType} from "@ots-frontend/ots-data";
import React, {useCallback} from "react";
import {getBadgedMarkerIcon, getDefaultMarkerIcon, MarkerIcon} from "../Marker/Marker";
import {EntityMarkerClusterer, EntityMarkerClusterProps} from "../EntityMarkerCluster/EntityMarkerCluster";
import {defaultMapMarkerColor, siteDisposalColor} from "../../../../theme/colors";
import {isEqual} from "lodash";

export type SiteMarkerBadge = {
  count: number
  /** Turns the badge red, e.g. a container at the site is critical. */
  alert?: boolean
}

export type SiteMarkerClustererProps = EntityMarkerClusterProps<SiteEntity> & {
  /** A count on the pin, e.g. loads ready; none when undefined or zero. */
  badge?: (site: SiteEntity) => SiteMarkerBadge | undefined
}

export const SiteMarkerClusterer = (props: SiteMarkerClustererProps) => {
  const {icon, iconColor, badge, ...rest} = props;

  const getIcon = useCallback((s: SiteEntity) => {
    let markerIcon: MarkerIcon | undefined;

    if (icon instanceof Function) {
      markerIcon = icon(s);
    } else {
      markerIcon = icon;
    }

    if (!markerIcon) {
      let color: string | undefined = undefined
      if (iconColor instanceof Function) {
        color = iconColor(s)
      } else if (iconColor) {
        color = iconColor
      } else if (isDisposalType(s.type)) {
        color = siteDisposalColor
      }

      const siteBadge = badge?.(s)
      markerIcon = siteBadge && siteBadge.count > 0
        ? getBadgedMarkerIcon(color ?? defaultMapMarkerColor, siteBadge.count, siteBadge.alert)
        : getDefaultMarkerIcon(color ?? defaultMapMarkerColor)
    }
    return markerIcon;
  }, [icon, iconColor, badge]);

  return (
    <EntityMarkerClusterer {...rest} icon={getIcon}/>
  );
};

export const SiteMarkerClustererMemo = React.memo(
  SiteMarkerClusterer,
  isEqual
);
